<template>
  <v-card class="pa-4 mb-4">
    <v-card-title>Prenotazioni per sport</v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="6">
          <v-data-table
              :headers="headers"
              :items="processedTableData"
              hide-default-footer
              dense
              class="elevation-1"
              :items-per-page="100"
          >
            <template v-slot:item.total="{ item }">
              <strong>{{ item.total }}</strong>
            </template>
            <template v-slot:item.percent="{ item }">
              {{ item.percent.toFixed(1) }}%
            </template>

            <template v-slot:item="{ item, index }">
              <tr>
                <td>{{ item.sport_name }}</td>
                <td class="text-right font-weight-bold">{{ item.total }}</td>
                <td class="text-right">{{ item.percent.toFixed(1) }}%</td>
              </tr>
            </template>
          </v-data-table>
        </v-col>

        <v-col cols="12" md="6" class="d-flex align-center justify-center">
          <apexchart
              v-if="pieSeries.length > 0"
              type="pie"
              width="100%"
              height="400"
              :series="pieSeries"
              :options="pieOptions"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'TableReservationBySport',
  components: { apexchart: VueApexCharts },
  props: {
    filters: Object,
    sports: Array
  },
  data() {
    return {
      sportsMap: {},
      rawData: [],
      processedTableData: [],
      headers: [
        { text: 'Sport', value: 'sport_name' },
        { text: 'Tot.', value: 'total', align: 'right' },
        { text: '%', value: 'percent', align: 'right' }
      ],
      pieSeries: [],
      pieOptions: {
        labels: [],
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            const total = opts.w.globals.seriesTotals.reduce((a, b) => a + b, 0);
            const percent = (val / total * 100).toFixed(1);
            return `${percent}%`;
          }
        },
        legend: { position: 'bottom' },
        tooltip: {
          y: {
            formatter: val => `${val} prenotazioni`
          }
        }
      },
      maxValue:0
    };
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler(newFilters) {
        this.fetchData(newFilters);
      }
    },
    sports: {
      deep: true,
      immediate: true,
      handler() {
        this.buildSportMap();
        this.fetchData(this.filters);
      }
    }
  },
  methods: {
    buildSportMap() {
      this.sportsMap = {};
      for (let i = 0; i < this.sports.length; i++) {
        const sport = this.sports[i];
        this.sportsMap[String(sport._id)] = sport.name;
      }
    },

    async fetchData(filters) {
      if (!Object.keys(this.sportsMap).length) {
        this.buildSportMap();
      }

      const result = await this.$store.dispatch('analytics/getReservationsBySport', filters);
      this.rawData = result;

      // --- TABELLA ---
      const total = result.reduce((sum, r) => sum + r.total, 0);
      let maxValue = 0;

      this.processedTableData = result.map(r => {
        const name = this.sportsMap[String(r.sport_id)] || `ID ${r.sport_id}`;
        const percent = total > 0 ? (r.total / total * 100) : 0;
        if (r.total > maxValue) maxValue = r.total;

        return {
          sport_name: name,
          total: r.total,
          percent: percent
        };
      }).sort((a, b) => b.total - a.total);

      this.maxValue = maxValue;

      // --- GRAFICO ---
      const mainLabels = [];
      const mainSeries = [];
      let othersTotal = 0;

      for (let i = 0; i < result.length; i++) {
        const r = result[i];
        const name = this.sportsMap[String(r.sport_id)] || `ID ${r.sport_id}`;
        const percent = (r.total / total) * 100;

        if (percent >= 5) {
          mainLabels.push(name);
          mainSeries.push(r.total);
        } else {
          othersTotal += r.total;
        }
      }

      if (othersTotal > 0) {
        mainLabels.push('Altro');
        mainSeries.push(othersTotal);
      }

      this.pieSeries = mainSeries;
      this.pieOptions = this.generatePieOptions(mainLabels, mainSeries);

    },
    generatePieOptions(labels, series) {
      return {
        labels: labels,
        legend: { position: 'bottom' },
        tooltip: {
          y: {
            formatter: val => `${val} prenotazioni`
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (percent) {
            return percent >= 0.1 ? percent.toFixed(1) + '%' : '<0.1%';
          }
        }
      };
    },
  }
};
</script>
<style scoped>
</style>